import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk, EntityId } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: modsfactoryUrls.categoryPath(value.target_id, value.id),
    image_url: modsfactoryUrls.remoteUrl(value.image_url)
  };
}

const subcategoriesEntity = new schema.Entity(
  'subcategories',
  {},
  {
    processStrategy
  }
);

const categoriesEntity = new schema.Entity(
  'categories',
  {
    subcategories: [subcategoriesEntity]
  },
  {
    processStrategy
  }
);

const categoryEntity = new schema.Entity(
  'category',
  {
    subcategories: [subcategoriesEntity]
  },
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize(response.data.category, categoryEntity);
  const { category, subcategories} = normalized.entities;

  return {
    categories: { ...category, ...subcategories }
  }
}

export const fetchCategories = createAsyncThunk(
  `${PREFIX}_categories/fetchCategories`,
  async (params: object = {}) => {
    const response = await modsFactoryApi.get(`/onesky/categories`, { params })
    const normalized = normalize(response.data, [categoriesEntity]);
    const { categories, subcategories } = normalized.entities;

    return {
      categories: { ...categories, ...subcategories },
      ids: normalized.result
    };
  }
);

export const fetchCategory = createAsyncThunk(
  `${PREFIX}_categories/fetchCategory`,
  async (id: number) => {
    const response = await modsFactoryApi.get(`/onesky/categories/${id}`)

    return normalizeInstance(response);
  }
);

export const createCategory = createAsyncThunk(
  `${PREFIX}_categories/createCategory`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.post(`/onesky/categories`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateCategory = createAsyncThunk(
  `${PREFIX}_categories/updateCategory`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/categories/${id}`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyCategory = createAsyncThunk(
  `${PREFIX}_categories/destroyCategory`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/categories/${id}`)

    return response.data;
  }
);

export const reorderCategories = createAsyncThunk(
  `${PREFIX}_categories/reorderCategories`,
  async ({ ids, reorderParentId }: { ids: any, reorderParentId: EntityId | null }, { rejectWithValue }) => {
    try {
      await modsFactoryApi.patch('/onesky/categories/reorder', { ids })

      return { ids, reorderParentId };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
